import { postRequest, getRequest, putRequest } from "../../utils/apiHelper";

export const profileService = {
    createProfile,
    getProfile,
    getProfileNames,
    saveProfileNames,

    getProjectUsers,
    getProjectClients,
    updateAgencyUserRole,
    deleteUser,
    deleteClientUser,

    getNotifications,
    getNotificationCount,
    getTasks,
    getInvites,
    updateNotification,
    updateNotificationViewStatus,
    deleteNotification,

    getGlobalData,

    inviteUserNew,
    newUserInvitationAccept,
    getNewUserInviteData,

    inviteClientUserNew,

    getInviteLink,
    getInviteFlowsAndClients,
    getAgencyDetailsCount,
    updateShowAppLogo,
    getEmailOtp,
    verifyOtp,
    resendOtp,

    updateFlowPermission,
    unSubscribeEmail,

    getAppConfig,
    updateAgencyProfile,
    verifyDomainRecords,

    publishCustomDomain,
    unPublishCustomDomain,

    publishPage,
    unPublishPage,

    saveAgencyEmailConfig,
    getAgencyEmailConfig,
    testAgencyEmailConfig,
    getAuthUrl,

    getApplicationApps,
    getUserConfiguredApps,

    getInvoiceNotification,
    updateSupportRestoreId,

    getWorkspaceNotification,
    removePublishedUrl,
    updateSupportRestoreId,
    getFunnelNotification,
    getOtherNotification,
    getClonedStatus,
    getAvatarUploadUrl,
    uploadAvatar
};

//create new profile
async function createProfile(params) {
    const response = await postRequest("profile/create", params);
    return response;
}

//get profile
async function getProfile(params) {
    const response = await postRequest("profile/get");
    return response;
}

//get profile
async function getProfileNames(params) {
    const response = await postRequest("profile/getNames");
    return response;
}

async function saveProfileNames(params) {
    const response = await postRequest("profile/saveNames", params);
    return response;
}

// inviteUserNew
async function inviteUserNew(params) {
    const response = await postRequest("profile/inviteUserNew", params);
    return response;
}

//get Team Members
async function newUserInvitationAccept(params) {
    const response = await postRequest("profile/inviteAccept", params);
    return response;
}

//getClientInviteData
async function getNewUserInviteData(params) {
    const response = await postRequest("profile/newInviteData", params);
    return response;
}

// invite New Clients
async function inviteClientUserNew(params) {
    const response = await postRequest("profile/inviteClientUserNew", params);
    return response;
}

//**************************************************TEAMS************************************************************* */

//get projectUsers
async function getProjectUsers(params) {
    const response = await postRequest("profile/teams");
    return response;
}

//get Clients names
async function getProjectClients(params) {
    const response = await postRequest("profile/teams/clients");
    return response;
}

//get projectUsers
async function updateAgencyUserRole(params) {
    const response = await postRequest("profile/updateRole", params);
    return response;
}

//deleteUser
async function deleteUser(params) {
    const response = await postRequest("profile/deleteUser", params);
    return response;
}

//deleteClientUser
async function deleteClientUser(params) {
    const response = await postRequest("profile/deleteClientUser", params);
    return response;
}

//**************************************************NOTIFICATIONS************************************************************* */

//get Notifications
async function getNotifications(params) {
    const response = await postRequest("profile/getNotifications", params);
    return response;
}

async function getNotificationCount(params) {
    // TODO: Implement getNotificationCount
}

//getTasks
async function getTasks(params) {
    const response = await postRequest("profile/getTasks", params);
    return response;
}

//getInvites
async function getInvites(params) {
    const response = await postRequest("profile/getInvites", params);
    return response;
}

async function getOtherNotification(params) {
    const response = await postRequest("profile/getOtherNotification", params);
    return response;
}

//updateNotification
async function updateNotification(params) {
    const response = await putRequest("notification/update_read_status", params);
    return response;
}

//updateNotificationViewStatus
async function updateNotificationViewStatus(params) {
    const response = await postRequest("profile/updateNotificationViewStatus", params);
    return response;
}

// To delete the notification
async function deleteNotification(params) {
    const response = await putRequest("notification/delete_notification", params);
    return response;
}

//**************************************************COMMON************************************************************* */

//getGlobalData
async function getGlobalData(params) {
    const response = await postRequest("general/search", params);
    return response;
}

async function getInviteLink(params) {
    const response = await postRequest("profile/copyInviteLink", params);
    return response;
}

async function getInviteFlowsAndClients() {
    const response = await getRequest("profile/flowsAndClients");
    return response;
}

async function getAgencyDetailsCount() {
    const response = await getRequest("profile/agencyDetailsCount");
    return response;
}

//Update show agency logo
async function updateShowAppLogo(params) {
    const response = await postRequest("profile/updateShowAppLogo", params);
    return response;
}

//email verification 
async function getEmailOtp(params) {
    const response = await postRequest("profile/emailChangeAuth", params);
    return response;
}

async function verifyOtp(params) {
    const response = await postRequest("profile/emailotpVerification", params);
    return response;
}

async function resendOtp(params) {
    const response = await postRequest("profile/resendEmail", params)
    return response
}

async function updateFlowPermission(params) {
    const response = await postRequest("profile/updateFlowPermission", params)
    return response;
}

// email un-subscription using public link
async function unSubscribeEmail(params) {
    const response = await postRequest("profile/openEmailUnsubscription", params)
    return response;
}

// get app config data like title, logo, icon, etc.,
async function getAppConfig(params) {
    const response = await postRequest("profile/getAppConfig", params)
    return response;
}

// publish domain
async function publishPage(params) {
    const response = await postRequest(
        `domain/create`,
        params,
        false,
        "json",
        "pageBuilder"
    );
    return response;
}

// unpublish Domain
async function unPublishPage(params) {
    const response = await postRequest(
        `domain/update`,
        params,
        false,
        "json",
        params?.apiType || "pageBuilder"
    );
    return response;
}

// publish domain
async function publishCustomDomain(params) {
    const response = await postRequest(
        `domain/create`,
        params,
        false,
        "json",
        "customDomain"
    );
    return response;
}

// unpublish Domain
async function unPublishCustomDomain(params) {
    const response = await postRequest(
        `domain/update`,
        params,
        false,
        "json",
        "customDomain"
    );
    return response;
}


async function updateAgencyProfile(params) {
    const response = await postRequest("profile/updateAgencyDetails", params);
    return response;
}

async function saveAgencyEmailConfig(params) {
    const response = await postRequest("profile/saveAgencyEmailConfig", params);
    return response;
}

async function getAgencyEmailConfig() {
    const response = await getRequest("profile/getAgencyEmailConfig");
    return response;
}

async function testAgencyEmailConfig(params) {
    const response = await postRequest("profile/testAgencyEmailConfig", params);
    return response;
}

async function getAuthUrl(params, pageType) {
    const response = await postRequest(`events/getAuthUrl/${pageType}`, params)
    return response;
}

async function getApplicationApps(params) {
    const response = await getRequest("profile/getApplicationApps");
    return response;
}

async function getUserConfiguredApps(params) {
    const response = await getRequest("profile/getUserApps");
    return response;
}

async function getInvoiceNotification(params) {
    const response = await postRequest("profile/getInvoiceNotification", params);
    return response;
}
async function getFunnelNotification(params) {
    const response = await postRequest("profile/getFunnelNotification", params);
    return response;
}

async function verifyDomainRecords(params) {
    const response = await postRequest("profile/verifyDomainRecords", params);
    return response;
}

async function removePublishedUrl(params) {
    const response = await postRequest("profile/remove_domain", params);
}
async function updateSupportRestoreId(params) {
    const response = await putRequest("profile/support_restore_id", params);
    return response;
}

async function getWorkspaceNotification(params) {
    const response = await postRequest("profile/getWorkspaceNotification", params);
    return response;
}
async function getClonedStatus(params) {
    const response = await postRequest("profile//checkClonedStatus", params);
    return response;
}

async function getAvatarUploadUrl() {
    const response = await postRequest("profile/getAvatarUploadUrl");
    return response;
}

async function uploadAvatar(file) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("files", file);
    
    const response = await postRequest(
        "profile/uploadAvatar",
        formData,
        true,
        undefined,
        "default",
        undefined
    );
    return response;
}
